import React from "react";

import ReusableModal from "components/Modals/ReusableModal";

const DeleteCommissionRuleModal = ({
    isOpen,
    onClose,
    onConfirm,
    rule,
}) => {
    if (!rule) return null;

    const bodyMessage = `
        Are you sure you want to delete the commission rule
        "<strong>${rule.milestone_type}</strong>"?
        <br /><br />
        This action cannot be undone.
    `;

    return (
        <ReusableModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            title="Delete Commission Rule"
            bodyMessage={
                <div
                    dangerouslySetInnerHTML={{
                        __html: bodyMessage,
                    }}
                />
            }
            confirmLabel="Delete"
            cancelLabel="Cancel"
        />
    );
};

export default DeleteCommissionRuleModal;